<template>
  <div>
    <v-row>
      <v-col class="mb-0" cols="6">
        <v-autocomplete
          v-model="level"
          item-text="text"
          item-value="value"
          :items="levels"
          outlined
          clearable
          label="Level"
          hide-details
        ></v-autocomplete
      ></v-col>

      <v-col class="m-0" cols="6">
        <v-autocomplete
          class="ma-0"
          v-model="programme"
          item-text="name"
          item-value="id"
          :items="programmes"
          outlined
          clearable
          label="Programme"
          hide-details
        ></v-autocomplete
      ></v-col>

      <v-col class="mb-0" cols="6">
        <v-autocomplete
          v-model="faculty"
          item-text="name"
          item-value="id"
          :items="faculties"
          outlined
          clearable
          label="Faculty"
          hide-details
        ></v-autocomplete>
      </v-col>

      <v-col cols="6">
        <v-autocomplete
          v-model="department"
          item-text="name"
          item-value="id"
          :items="departments"
          outlined
          clearable
          small
          label="Department"
          hide-details
        ></v-autocomplete>
      </v-col>

      <!-- <v-col cols="6">
      <v-autocomplete
        v-model="course"
        item-text="name"
        item-value="id"
        :items="courses"
        filled
        clearable
        label="Course"
        hide-details
      ></v-autocomplete>
    </v-col> -->

      <!-- <v-col cols="6">
      <v-autocomplete
        v-model="state"
        item-text="text"
        item-value="id"
        :items="states"
        filled
        clearable
        label="State"
        hide-details
      ></v-autocomplete>
    </v-col> -->

      <!-- <v-col cols="6">
      <v-autocomplete
        v-model="lga"
        item-text="name"
        item-value="id"
        :items="lgas"
        filled
        clearable
        label="LGA"
        hide-details
      ></v-autocomplete>
    </v-col> -->
    </v-row>
    <v-btn outlined class="mt-4" @click="applyRestrictions"
      >Apply Restrictions</v-btn
    >
  </div>
</template>



<script>
import { formatName } from "../../tools/format";

const LEVELS = [
  { text: "100", value: 1 },
  { text: "200", value: 2 },
  { text: "300", value: 3 },
  { text: "400", value: 4 },
  { text: "500", value: 5 },
  { text: "600", value: 6 },
  { text: "700", value: 7 },
  { text: "800", value: 8 },
  { text: "900", value: 9 },
  { text: "1000", value: 10 },
  { text: "1100", value: 11 },
  { text: "1200", value: 12 },
];

export default {
  data: () => ({
    lgas: [],
    states: [],
    courses: [],
    sessions: [],
    faculties: [],
    programmes: [],
    departments: [],
    levels: LEVELS,

    lga: null,
    state: null,
    course: null,
    session: null,
    faculty: null,
    programme: null,
    department: null,
    level: null,

    query: null,
  }),

  methods: {
    loadLGAs() {
      this.$axios.get("/lgas").then(async ({ data: lgas }) => {
        this.lgas = lgas;
      });
    },

    getLGAName() {
      const lga = this.lgas.find((l) => l.id == this.lga);
      return lga ? `${lga.name} LGA` : "any LGA";
    },

    loadStates() {
      this.$axios.get("/states").then(async ({ data: states }) => {
        this.states = states.map((s) => {
          s.text = formatName(s.name);
          return s;
        });
      });
    },

    getStateName(id) {
      const state = this.states.find((s) => s.id == id);
      return state ? ` of ${state.text} State` : "";
    },

    loadCourses() {
      this.$axios.get("/courses").then(async ({ data: courses }) => {
        this.courses = courses;
      });
    },

    getCourseName() {
      return (
        this.courses.find((c) => c.id == this.course)?.name || "any course"
      );
    },

    loadFaculties() {
      this.$axios.get("/faculties").then(async ({ data: faculties }) => {
        this.faculties = faculties;
      });
    },

    getFacultyName() {
      const faculty = this.faculties.find((f) => f.id == this.faculty);
      return faculty ? `Faculty of ${faculty.name}` : "all faculties";
    },

    loadDepartments() {
      this.$axios.get("/departments").then(async ({ data: departments }) => {
        this.departments = departments;
      });
    },

    getDepartmentName() {
      const department = this.departments.find((p) => p.id == this.department);
      return department ? `Department of ${department.name}` : "any department";
    },

    loadProgrammes() {
      this.$axios.get("/programmes").then(async ({ data: programmes }) => {
        this.programmes = programmes;
      });
    },

    getProgrammeName() {
      return this.programmes.find((p) => p.id == this.programme)?.name || "all";
    },

    composeQuery(page) {
      let query = `
        ${this.page ? `page=${page}&` : ""}
        ${this.session ? `session=${this.session}&` : ""}
        ${this.programme ? `programme=${this.programme}&` : ""}
        ${this.faculty ? `faculty=${this.faculty}&` : ""}
        ${this.department ? `department=${this.department}&` : ""}
        ${this.course ? `course=${this.course}&` : ""}
        ${this.state ? `state=${this.state}&` : ""}
        ${this.lga ? `lga=${this.lga}&` : ""}
      `
        .slice(0, -1)
        .replace(/\s+/g, "");

      return String(query).slice(0, -1).replace(/\s+/g, "");
    },

    applyRestrictions() {
      const restrictions = {};
      this.level && (restrictions.level = this.level);
      this.department && (restrictions.department_id = this.department);
      this.faculty && (restrictions.faculty_id = this.faculty);
      this.programme && (restrictions.programme_id = this.programme);

      if (Object.keys(restrictions).length > 0) {
        this.$emit("restrictions", restrictions);
      }
    },
  },

  mounted() {
    // this.loadLGAs();
    // this.loadStates();
    // this.loadCourses();
    this.loadDepartments();
    this.loadFaculties();
    this.loadProgrammes();
  },
};
</script>